<div class="fs-2 with-close" mat-dialog-title>
    Signaler une erreur
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p>
        Merci de nous aider à améliorer notre site ! Veuillez fournir le plus de détails possible sur le bug rencontré. Notre application étant complexe, chaque détail peut nous aider à identifier plus facilement l'origine du problème.
    </p>
    <form (ngSubmit)="onYesClick()">
        <mat-form-field class="lines-2">
            <mat-label>Quel est le problème rencontré ? </mat-label>
            <textarea matInput [(ngModel)]="error"></textarea>
        </mat-form-field>

        <mat-form-field class="lines-2">
            <mat-label>À quel résultat vous attendiez-vous ?</mat-label>
            <textarea matInput [(ngModel)]="comment"></textarea>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
